import { ISearchRepository } from "$src/domain/searches/ISearchRepository";
import { injectable } from "tsyringe";
import { ApiRoutes } from "../apiConfig/ApiRoutes";
import { BaseApi } from "../apiConfig/BaseApi";
import { PagedResult } from "$src/domain/core/PagedResult";
import { SearchResult } from "$src/domain/searches/SearchResult";
import { plainToInstance } from "class-transformer";

@injectable()
export class SearchRepositoryApi extends BaseApi implements ISearchRepository {
  
    private static ROUTES = 
    {
        global: 'global',
    };

    protected static getRoute(groupStoreId: string, path: string) : string {
        return `${ApiRoutes.SEARCHES.endpoint(groupStoreId)}/${path}`;
    }

    async search(groupStoreId: string, query: string, pageNumber: number, pageSize: number): Promise<PagedResult<SearchResult>> {
        try {

            const route = SearchRepositoryApi.getRoute(groupStoreId, SearchRepositoryApi.ROUTES.global);

            const response = await this.apiClient.get<PagedResult<SearchResult>>(route, 
            {
                pageNumber: pageNumber,
                pageSize: pageSize,
                search: query
            })
            
            return response;
        } catch (error) {
            console.error('Error fetching search results:', error);
            throw error; 
        }
    }
}
